<template>
  <div class="pt-2 pl-4">
    <p>{{ $i18nPresenter.t('Link for moderators:') }}</p>
    <div class="inline-flex items-center w-full">
      <aha-clipboard-general
        :value="moderationLink"
        icon-name="open-new-window"
        class="moderation-link__clipboard-input"
        :tooltipText="$i18nPresenter.t('Open in a new tab')"
        @click="openModerationLinkInNewTab"
      />
      <span class="w-4 h-4 mr-2">
        <aha-icon
          name="reset"
          class="mb-1.5 primary-icon"
          @click="handleGenerateModerationLink"
          v-if="!generatingModerationLink"
          v-tooltip="$i18nPresenter.t('Regenerate link')"
        />
        <aha-spinner
          size="xs"
          variant="dark"
          class="moderation-link__spinner"
          v-else
        />
      </span>
      <div class="font-bold primary-icon">
        <aha-icon
          name="copy"
          v-clipboard="() => moderationLink"
          v-tooltip="$i18nPresenter.t('Copy')"
          v-clipboard:success="showToasterCopySuccess"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    moderationLink: {
      type: String,
      default: '',
    },
    handleGenerateModerationLink: {
      type: Function,
      default: () => {},
    },
    openModerationLinkInNewTab: {
      type: Function,
      default: () => {},
    },
    showToasterCopySuccess: {
      type: Function,
      default: () => {},
    },
    generatingModerationLink: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.primary-icon {
  @apply text-primary-90 hover:text-primary-100 cursor-pointer;
}
.moderation-link__clipboard-input {
  @apply mt-1 w-0 flex-grow;
  &::v-deep .aha-clipboard-button {
    @apply text-secondary-20 hover:text-primary-90;
  }
}
.moderation-link__spinner {
  margin-bottom: -0.5px;
}
</style>
